/**
 * Generate a fresh idempotency key for a mutating admin API call. The admin
 * routes reject POST requests lacking the `idempotency-key` header, so
 * every mutation hook derives one before dispatch.
 */
export function freshIdempotencyKey(prefix = 'admin-web'): string {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}-${Date.now().toString(36)}-${rand}`;
}
